export type PasswordStrength = "weak" | "medium" | "strong" | null

export interface PasswordValidation {
  hasMinLength: boolean
  hasUpperCase: boolean
  hasLowerCase: boolean
  hasNumber: boolean
  hasSpecialChar: boolean
}

export interface LoginFormData {
  email: string
  password: string
  rememberMe: boolean
}

export interface SignUpFormData {
  fullName: string
  email: string
  password: string
  confirmPassword: string
}

export interface ResetPasswordFormData {
  otp: string
  password: string
  confirmPassword: string
}

export interface ForgotPasswordFormData {
  email: string
}

export interface OtpVerificationFormData {
  otp: string[]
}

export enum AuthStatus {
  LOADING = "loading",
  SUCCEEDED = "succeeded",
  FAILED = "FAILED", 
}

